module.exports = __webpack_public_path__ + "static/media/betaald_color.e53add21.svg";